(function(){
"use strict";
var FQ_DIRTY=false;  // true = quiz in corso, avvisa prima di ricaricare/uscire
// --- rete di sicurezza: se la configurazione manca o è rotta, si va avanti lo stesso ---
if(!window.FQ_CONFIG){
  console.error("FQ: configurazione mancante o con errore di sintassi. Uso i valori di riserva.");
  window.FQ_CONFIG={};
}
var _D={formula:{variantId:0,preis:0,preisVergleich:null,label:"",detail:""},
        bilder:{bereiche:{},kunden:[]},ronaldo:{titel:"",text:""},stimmen:[],
        zutaten:[],faq:[],upsell:[],maxUpsell:3,demo:true};
for(var _k in _D){ if(window.FQ_CONFIG[_k]==null) window.FQ_CONFIG[_k]=_D[_k]; }
if(!window.FQ_CONFIG.bilder.bereiche) window.FQ_CONFIG.bilder.bereiche={};
if(!window.FQ_CONFIG.bilder.kunden)   window.FQ_CONFIG.bilder.kunden=[];

const C=window.FQ_CONFIG,R=document.getElementById("fq"),$=s=>R?R.querySelector(s):null;
if(!R){ console.error("FQ: contenitore #fq non trovato."); return; }
const IMG=C.bilder||{};

/* ---------- DOSE ---------- */
function jar(){
  if(IMG.produkt) return `<img src="${IMG.produkt}" alt="Your Personal Formula">`;
  let g="";
  for(let i=0;i<130;i++){
    const x=92+Math.random()*136,y=96+Math.random()*30,r=1.5+Math.random()*2.2;
    const c=["#e8a33d","#d9743a","#f0d9a8","#c9542f","#efe3c4"][Math.floor(Math.random()*5)];
    g+=`<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${c}" opacity="${(.6+Math.random()*.4).toFixed(2)}"/>`;
  }
  return `<svg viewBox="0 0 320 360" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="jb" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#3b3193"/><stop offset="26%" stop-color="#6155e0"/>
        <stop offset="62%" stop-color="#8b7dff"/><stop offset="100%" stop-color="#3f3499"/></linearGradient>
      <linearGradient id="jl" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0%" stop-color="#4a3fc4"/><stop offset="45%" stop-color="#7a6cf0"/><stop offset="100%" stop-color="#453ab0"/></linearGradient>
      <clipPath id="jc"><rect x="88" y="92" width="144" height="40"/></clipPath>
    </defs>
    <ellipse cx="160" cy="336" rx="86" ry="12" fill="#0d1024" opacity=".13"/>
    <path d="M88 112 h144 v186 a22 22 0 0 1 -22 22 h-100 a22 22 0 0 1 -22 -22 z" fill="url(#jb)"/>
    <ellipse cx="160" cy="112" rx="72" ry="20" fill="#241d6b"/>
    <g clip-path="url(#jc)"><ellipse cx="160" cy="112" rx="66" ry="17" fill="#1a1550"/>${g}</g>
    <rect x="82" y="74" width="156" height="34" rx="10" fill="url(#jl)"/>
    <rect x="82" y="74" width="156" height="8" rx="4" fill="#fff" opacity=".18"/>
    <rect x="104" y="176" width="112" height="82" rx="8" fill="#fff" opacity=".93"/>
    <text x="160" y="200" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">DEINE</text>
    <text x="160" y="219" text-anchor="middle" font-family="Sora,sans-serif" font-size="13" font-weight="700" fill="#171a33">FORMEL</text>
    <line x1="120" y1="228" x2="200" y2="228" stroke="#d8dce8"/>
    <text x="160" y="245" text-anchor="middle" font-family="Azeret Mono,monospace" font-size="6.5" fill="#5d6382" letter-spacing="1.2">30 DAYS · 2 SCOOPS</text>
    <rect x="88" y="112" width="16" height="208" fill="#fff" opacity=".10"/>
  </svg>`;
}
$("#fq-jar1").innerHTML=(IMG.hero?`<img src="${IMG.hero}" alt="Your Personal Formula">`:jar())
  +`<div class="fq-scoops">Usage<b>2 scoops / day</b></div>`;

/* ---------- BILD-SLOTS ---------- */
function slot(id,url,ph){
  const el=$(id); if(!el) return;
  el.innerHTML = url ? `<img src="${url}" alt="">` : `<span class="ph">${ph}</span>`;
}
slot("#fq-im-granulat", IMG.granulat, "Bild: Granulate");
slot("#fq-im-bewertung", IMG.bewertung, "Bild: Wellness-Check");
slot("#fq-im-aufnahme",  IMG.aufnahme,  "Bild: Aufnahme");
slot("#fq-im-qualitaet", IMG.qualitaet, "Image: Quality");
if(IMG.anwendung){const s=$("#fq-step4");
  if(s) s.querySelector(".ic").outerHTML=`<img src="${IMG.anwendung}" alt="Einnahme">`;}

/* ---------- ZUTATEN-LAUFBAND ---------- */
(function(){
  const z=(C.zutaten||[]);
  const chip=x=>`<span class="fq-z">${x.bild?`<img src="${x.bild}" alt="">`:`<i></i>`}${x.name}</span>`;
  $("#fq-track").innerHTML = z.map(chip).join("") + z.map(chip).join("");  // duplicated for seamless loop
})();

/* ---------- VIER BEREICHE ---------- */
const BEREICHE=[
 {k:"haut", tab:"Bellezza e Benessere", h:"Bellezza e benessere",
  p:"Per chi vuole sentirsi bene nella propria pelle — e mostrarlo.",
  b:["Contribuisce al mantenimento di una pelle normale","Contribuisce al mantenimento di capelli e unghie normali",
     "Contribuisce alla normale formazione di collagene","Aiuta a proteggere le cellule dallo stress ossidativo"]},
 {k:"kraft", tab:"Sport e Performance", h:"Sport e performance",
  p:"Per le persone attive che vogliono sostenere la performance fisica con la nutrizione.",
  b:["Contribuisce alla normale funzione muscolare","Contribuisce al normale metabolismo energetico",
     "Aiuta a ridurre stanchezza e affaticamento","Contribuisce al mantenimento di ossa normali"]},
 {k:"geist", tab:"Funzione Cognitiva", h:"Funzione cognitiva e psicologica",
  p:"Per chi tiene alla concentrazione e alla lucidità mentale ogni giorno.",
  b:["Contribuisce alla normale funzione del sistema nervoso","Contribuisce alla normale funzione cognitiva",
     "Contribuisce alla normale funzione psicologica"]},
 {k:"altern", tab:"Benessere a lungo termine", h:"Benessere a lungo termine",
  p:"Per chi pensa a tutto il corpo e agli anni a venire.",
  b:["Contribuisce al mantenimento di ossa normali","Contribuisce alla normale funzione del sistema immunitario",
     "Contribuisce alla normale funzione cardiaca","Aiuta a proteggere le cellule dallo stress ossidativo"]}
];
function bereich(i){
  const b=BEREICHE[i];
  const url=(IMG.bereiche||{})[b.k];
  $("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,j)=>t.classList.toggle("on",j===i));
  $("#fq-panel").innerHTML=`<div class="fq-panel">
    <div class="fq-pimg">${url?`<img src="${url}" alt="">`:`<span class="ph">Bild: ${b.tab}</span>`}</div>
    <div><h3>${b.h}</h3><p>${b.p}</p>
      <ul class="fq-bl">${b.b.map(x=>`<li>${x}</li>`).join("")}</ul>
      <button class="fq-btn" data-a="start">Meine Formel erstellen</button>
    </div></div>`;
}
$("#fq-tabs").innerHTML=BEREICHE.map((b,i)=>`<button class="fq-tab" data-b="${i}">${b.tab}</button>`).join("");
$("#fq-tabs").querySelectorAll(".fq-tab").forEach((t,i)=>t.addEventListener("click",()=>bereich(i)));
bereich(0);

/* ---------- RONALDO (only if filled in config) ---------- */
(function(){
  const r=C.ronaldo||{};
  if(!r.text || !r.text.trim()) return;
  $("#fq-ron-sec").style.display="block";
  $("#fq-ron-t").textContent=r.titel||"";
  $("#fq-ron-p").textContent=r.text;
  $("#fq-ron-img").innerHTML=IMG.ronaldo?`<img src="${IMG.ronaldo}" alt="">`:"";
})();

/* ---------- KUNDEN (nur wenn Fotos oder Stimmen vorhanden) ---------- */
(function(){
  const fotos=IMG.kunden||[], stimmen=C.stimmen||[];
  if(!fotos.length && !stimmen.length) return;
  $("#fq-kunden-sec").style.display="block";
  if(fotos.length){
    const im=u=>`<img src="${u}" alt="">`;
    $("#fq-ktrack").innerHTML=fotos.map(im).join("")+fotos.map(im).join("");
  } else { $("#fq-ktrack").parentElement.style.display="none"; }
  $("#fq-stimmen").innerHTML=stimmen.map(s=>
    `<div class="fq-stimme"><p>„${s.text}"</p>
     <div class="who">${s.bild?`<img src="${s.bild}" alt="">`:""}<span>${s.name}</span></div></div>`).join("");
})();

/* ---------- FAQ ---------- */
(function(){
  const f=C.faq||[];
  $("#fq-faq").innerHTML=f.map((x,i)=>
    `<div class="fq-fi" data-i="${i}">
       <button class="fq-fq" type="button"><span>${x.f}</span><span class="x">+</span></button>
       <div class="fq-fa"><p>${x.a}</p></div>
     </div>`).join("");
  $("#fq-faq").querySelectorAll(".fq-fq").forEach(btn=>btn.addEventListener("click",()=>{
    const it=btn.parentElement;
    const wasOpen=it.classList.contains("on");
    $("#fq-faq").querySelectorAll(".fq-fi").forEach(x=>x.classList.remove("on"));
    if(!wasOpen) it.classList.add("on");
  }));
})();

/* ---------- DIE 7 BEREICHE ---------- */
const AREE={
 energie:{n:"Energia",s:"Energia",d:"Ferro, magnesio e vitamine del gruppo B contro i cali di giornata.",
  nutri:[["Vitamina B12","Globuli rossi ed energia"],["Ferro","Trasporto dell'ossigeno"],["Magnesio","Muscoli, sonno ed energia"],["Vitamina B6","Umore e sistema nervoso"],["Acido pantotenico","Metabolismo energetico"]]},
 geist:{n:"Funzione Cognitiva",s:"Mente",d:"Supporto per concentrazione, memoria e lucidità.",
  nutri:[["Omega-3 DHA","Struttura cerebrale"],["Vitamina B6","Neurotrasmettitori"],["Iodio","Ormone tiroideo"],["Zinco","Funzione cognitiva"]]},
 kraft:{n:"Forza Muscolare",s:"Forza",d:"Proteine, magnesio e minerali per allenamento e recupero.",
  nutri:[["Magnesio","Contrazione muscolare"],["Vitamina D3","Muscoli e ormoni"],["Zinco","Recupero"],["Potassio","Equilibrio elettrolitico"]]},
 knochen:{n:"Ossa",s:"Ossa",d:"Calcio, vitamina D3 e K2 per la densità ossea.",
  nutri:[["Calcio","Ossa e denti"],["Vitamina D3","Assorbimento del calcio"],["Vitamina K2","Fissa il calcio nelle ossa"],["Manganese","Tessuto connettivo"]]},
 herz:{n:"Cuore",s:"Cuore",d:"Omega-3 e antiossidanti per il sistema cardiovascolare.",
  nutri:[["Omega-3 EPA","Funzione cardiaca"],["Vitamina K2","Elasticità delle arterie"],["Folati","DNA e globuli rossi"],["Niacina","Livelli di colesterolo"]]},
 haut:{n:"Pelle e Capelli",s:"Pelle",d:"Biotina, zinco e vitamina C per il rinnovo dei tessuti.",
  nutri:[["Biotina","Capelli, pelle e unghie"],["Zinco","Rinnovo cellulare"],["Vitamina C","Formazione di collagene"],["Vitamina E","Protezione della pelle"],["Vitamina A","Rinnovo dei tessuti"]]},
 altern:{n:"Invecchiamento Sano",s:"Invecchiamento",d:"Antiossidanti e protezione cellulare nel tempo.",
  nutri:[["Selenio","Antiossidante e tiroide"],["Vitamina E","Protezione cellulare"],["Coenzima Q10","Energia cellulare"],["Luteina","Occhi e vista"],["Vitamina C","Immunità e collagene"]]}
};
const K=Object.keys(AREE);

/* ---------- DIE 25 FRAGEN ---------- */
const Q=[
 {s:"Profilo",t:"Come ti chiami?",h:"Solo per etichettare la tua formula.",type:"text",lab:"Nome",ph:"Il tuo nome"},
 {s:"Profilo",t:"Quando sei nato/a?",type:"date",lab:"Data di nascita",
  sc:v=>{const a=new Date().getFullYear()-new Date(v).getFullYear();
         return a>=50?{knochen:3,altern:3,herz:2}:a>=35?{altern:2,herz:1}:{}}},
 {s:"Profilo",t:"Sesso biologico",h:"Cambia il tuo fabbisogno di ferro, calcio e altri nutrienti.",type:"ch",lab:"Sesso",two:1,
  o:[{t:"Femmina",p:{knochen:2,haut:1}},{t:"Maschio",p:{kraft:1}}]},
 {s:"Profilo",t:"Quanto sei alto/a?",type:"num",unit:"cm",min:120,max:230,lab:"Altezza",sc:()=>({})},
 {s:"Profilo",t:"Quanto pesi?",type:"num",unit:"kg",min:35,max:250,lab:"Peso",sc:()=>({})},

 {s:"Obiettivi",t:"Quali due aree vorresti sostenere di più?",h:"Scegline esattamente due.",type:"multi",need:2,lab:"Aree prioritarie",
  o:[{t:"Pelle e capelli",p:{haut:6}},{t:"Funzione cognitiva",p:{geist:6}},{t:"Energia e stanchezza",p:{energie:6}},
     {t:"Invecchiamento sano",p:{altern:6}},{t:"Cuore",p:{herz:6}},{t:"Ossa",p:{knochen:6}},{t:"Forza muscolare",p:{kraft:6}}]},
 {s:"Obiettivi",t:"Qual è il tuo obiettivo fitness attuale?",type:"ch",lab:"Obiettivo fitness",two:1,
  o:[{t:"Aumentare la massa muscolare",p:{kraft:5}},{t:"Perdere peso",p:{energie:3,altern:2}},
     {t:"Migliorare la resistenza",p:{energie:4,herz:3}},{t:"Sostenere il benessere generale",p:{altern:3,energie:2}}]},

 {s:"Alimentazione",t:"Segui uno di questi regimi alimentari?",h:"Seleziona tutto ciò che vale.",type:"multi",lab:"Alimentazione",two:1,
  o:[{t:"Vegetariana",p:{energie:3,kraft:2}},{t:"Vegana",p:{energie:5,kraft:3,knochen:2,geist:2}},
     {t:"Pescetariana",p:{herz:1}},{t:"Senza glutine",p:{}},{t:"Senza lattosio",p:{knochen:2}},
     {t:"Low-carb o chetogenica",p:{energie:1}},{t:"Nessun regime particolare",p:{},x:1}]},
 {s:"Alimentazione",t:"Quanto spesso mangi carne rossa?",type:"ch",lab:"Carne rossa",two:1,
  o:[{t:"Almeno 3 volte a settimana",p:{herz:1}},{t:"1–2 volte a settimana",p:{}},
     {t:"Qualche volta al mese",p:{energie:2}},{t:"Mai",p:{energie:4,kraft:1}}]},
 {s:"Alimentazione",t:"E pesce o frutti di mare?",type:"ch",lab:"Pesce",two:1,
  o:[{t:"Almeno 3 volte a settimana",p:{}},{t:"1–2 volte a settimana",p:{herz:1}},
     {t:"Qualche volta al mese",p:{herz:3,geist:2}},{t:"Mai",p:{herz:5,geist:4}}]},
 {s:"Alimentazione",t:"Quanti latticini al giorno?",type:"ch",lab:"Latticini",two:1,
  o:[{t:"Almeno 3 al giorno",p:{}},{t:"1–2 al giorno",p:{}},{t:"Qualche volta al mese",p:{knochen:3}},{t:"Mai",p:{knochen:5}}]},
 {s:"Alimentazione",t:"Quante porzioni di frutta al giorno?",type:"ch",lab:"Frutta",two:1,
  o:[{t:"Almeno 3 al giorno",p:{}},{t:"1–2 al giorno",p:{altern:1}},
     {t:"Qualche volta al mese",p:{altern:3,haut:2}},{t:"Mai",p:{altern:5,haut:3}}]},
 {s:"Alimentazione",t:"E quante porzioni di verdura?",h:"Contano anche insalate e zuppe.",type:"ch",lab:"Verdura",two:1,
  o:[{t:"Almeno 3 al giorno",p:{}},{t:"1–2 al giorno",p:{altern:1}},
     {t:"Qualche volta al mese",p:{altern:3,energie:2}},{t:"Mai",p:{altern:5,energie:3}}]},
 {s:"Alimentazione",t:"Quante porzioni di proteine al giorno?",h:"Carne, pesce, uova, legumi o frullati proteici.",type:"ch",lab:"Porzioni di proteine",two:1,
  o:[{t:"1 o meno",p:{kraft:5,energie:2}},{t:"2 porzioni",p:{kraft:3}},{t:"3 porzioni",p:{}},
     {t:"4 porzioni",p:{}},{t:"5 porzioni",p:{}},{t:"6 o più",p:{}}]},
 {s:"Alimentazione",t:"Quale pasto consumi a un orario fisso?",h:"Lo usiamo per allineare la tua finestra nutrizionale.",type:"ch",lab:"Pasto fisso",two:1,
  o:[{t:"Colazione",p:{}},{t:"Cena",p:{}}]},
 {s:"Alimentazione",t:"Quante bevande con caffeina al giorno?",type:"ch",lab:"Caffeina",two:1,
  o:[{t:"Almeno 3 al giorno",p:{energie:3}},{t:"1–2 al giorno",p:{energie:1}},{t:"Qualche volta al mese",p:{}},{t:"Mai",p:{}}]},
 {s:"Alimentazione",t:"Quanti liquidi bevi al giorno?",h:"Acqua, tè, caffè, latte, succhi. Un bicchiere = 250 ml.",type:"ch",lab:"Liquidi",two:1,
  o:[{t:"Meno di 4 bicchieri",p:{energie:3,haut:3}},{t:"5 bicchieri",p:{energie:2,haut:2}},{t:"6 bicchieri",p:{haut:1}},
     {t:"7 bicchieri",p:{}},{t:"8 bicchieri",p:{}},{t:"9 bicchieri",p:{}},{t:"10 bicchieri",p:{}},
     {t:"11 bicchieri",p:{}},{t:"12 o più",p:{}}]},
 {s:"Alimentazione",t:"Quante bevande zuccherate al giorno?",h:"Bibite gassate, succhi dolci, energy drink.",type:"ch",lab:"Bevande zuccherate",two:1,
  o:[{t:"Nessuna",p:{}},{t:"1 al giorno",p:{altern:1}},{t:"2 al giorno",p:{altern:3}},{t:"3 o più",p:{altern:5,herz:2}}]},

 {s:"Attività",t:"Come descriveresti il tuo livello di attività?",type:"ch",lab:"Livello di attività",two:1,
  o:[{t:"Sedentario o mobilità limitata",p:{energie:3,knochen:3,herz:2}},
     {t:"Poco attivo: lavoro d'ufficio, poco movimento",p:{energie:2,knochen:1}},
     {t:"Moderatamente attivo: 1–3 allenamenti a settimana",p:{kraft:2}},
     {t:"Molto attivo: allenamento quasi quotidiano",p:{kraft:4,energie:2}}]},
 {s:"Attività",t:"Che tipo di attività pratichi?",h:"Seleziona tutto ciò che vale.",type:"multi",lab:"Tipo di attività",two:1,
  o:[{t:"Allenamento di forza o palestra",p:{kraft:4,knochen:2}},{t:"Corsa, ciclismo o nuoto",p:{herz:3,energie:2}},
     {t:"Sport di squadra",p:{kraft:2,herz:2}},{t:"Yoga, Pilates o stretching",p:{geist:2}},
     {t:"Camminata",p:{herz:1}},{t:"Nessuna attività",p:{knochen:2,kraft:1},x:1}]},
 {s:"Attività",t:"Quanti giorni a settimana ti alleni?",type:"ch",lab:"Giorni di allenamento",two:1,
  o:[{t:"Non mi alleno",p:{knochen:2}},{t:"1 giorno",p:{}},{t:"2 giorni",p:{kraft:1}},
     {t:"3 giorni",p:{kraft:2}},{t:"4 giorni",p:{kraft:3}},{t:"5 o più",p:{kraft:4,energie:2}}]},

 {s:"Benessere",t:"Ti senti riposato/a dopo una normale notte di sonno?",type:"ch",lab:"Recupero dopo il sonno",two:1,
  o:[{t:"Sì",p:{}},{t:"No",p:{energie:5,geist:2}}]},
 {s:"Benessere",t:"Ti senti energico/a e lucido/a durante il giorno?",type:"ch",lab:"Energia e lucidità",two:1,
  o:[{t:"Sì",p:{}},{t:"No",p:{energie:5,geist:3}}]},
 {s:"Benessere",t:"Cosa deve sostenere la tua formula?",h:"Seleziona tutto ciò che vale.",type:"multi",lab:"Supporto desiderato",
  o:[{t:"Ridurre stanchezza e affaticamento",p:{energie:5}},{t:"Gestire lo stress quotidiano",p:{geist:4,energie:2}},
     {t:"Sostenere una vista normale",p:{altern:3,geist:1}},{t:"Rafforzare il sistema immunitario",p:{altern:3,haut:1}},
     {t:"Migliorare la qualità del sonno",p:{energie:3,geist:2}},{t:"Nessuna di queste",p:{},x:1}]},
 {s:"Benessere",t:"Come sono pelle, capelli e unghie in questo momento?",h:"Seleziona tutto ciò che vale.",type:"multi",lab:"Pelle e capelli",two:1,
  o:[{t:"Capelli fragili o caduta",p:{haut:4}},{t:"Pelle spenta o secca",p:{haut:3}},
     {t:"Unghie fragili",p:{haut:3}},{t:"Tutto nella norma",p:{},x:1}]}
];

const SAFE=[
 {t:"Hai allergie o intolleranze?",h:"Seleziona tutto ciò che vale. Serve a escludere ingredienti dalla tua formula.",type:"multi",lab:"Allergie",two:1,
  o:[{t:"Lattosio"},{t:"Glutine"},{t:"Frutta a guscio"},{t:"Soia"},{t:"Crostacei o pesce"},
     {t:"Altro — lo indico nelle note",f:1},{t:"Nessuna",x:1}]},
 {t:"Una di queste situazioni ti riguarda?",h:"Seleziona tutto ciò che vale.",type:"multi",lab:"Note mediche",two:1,
  o:[{t:"Assumo farmaci regolarmente",f:1},{t:"Sono incinta o allatto",f:1},
     {t:"Ho una patologia in corso",f:1},{t:"Nessuna di queste",x:1}]}
];
const ALL=Q.concat(SAFE.map(x=>Object.assign({s:"Sicurezza",extra:1},x)));

/* ---------- ENGINE ---------- */
const st={i:0,a:new Array(ALL.length).fill(null),plan:false,up:new Set()};
const stage=n=>R.querySelectorAll(".fq-stage").forEach(e=>e.classList.toggle("on",e.dataset.s===n));
const CX=150,CY=140,RR=98;
const pt=(i,v)=>{const a=-Math.PI/2+i*2*Math.PI/7,r=14+RR*v;return[CX+r*Math.cos(a),CY+r*Math.sin(a)];};
(function(){let g="";
 [.34,.67,1].forEach(f=>{g+=`<polygon class="fq-ring" points="${K.map((_,i)=>pt(i,f).map(n=>n.toFixed(1)).join(",")).join(" ")}"/>`;});
 K.forEach((k,i)=>{const[x,y]=pt(i,1);g+=`<line class="fq-axis" x1="${CX}" y1="${CY}" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}"/>`;
  const[lx,ly]=pt(i,1.25);
  g+=`<text class="fq-lab" x="${lx.toFixed(1)}" y="${(ly+3).toFixed(1)}" text-anchor="middle">${AREE[k].s.toUpperCase()}</text>`;});
 var _sc=$("#fq-scaffold"); if(_sc) _sc.innerHTML=g;})();

function scores(){const t={};K.forEach(k=>t[k]=0);
 st.a.forEach(a=>{if(!a)return;(a.ps||(a.p?[a.p]:[])).forEach(p=>{for(const k in p)t[k]+=p[k];});});return t;}
function radar(){var poly=$("#fq-poly"); if(!poly) return;
 const t=scores(),m=Math.max(6,...Object.values(t));
 poly.setAttribute("d","M"+K.map((k,i)=>pt(i,.1+.9*(t[k]/m)).map(n=>n.toFixed(1)).join(",")).join("L")+"Z");
 const n=st.a.filter(Boolean).length;
 var rf=$("#fq-rf"); if(rf) rf.textContent=n?n+" risposte lette":"In attesa della tua prima risposta";}
radar();

function render(){
 const q=ALL[st.i],a=st.a[st.i];
 $("#fq-sec").textContent=q.s;$("#fq-cur").textContent=Math.min(st.i+1,25);
 $("#fq-fill").style.width=(st.i/ALL.length*100)+"%";
 let body="";
 if(q.type==="ch"||q.type==="multi"){
  body=`<div class="fq-opts${q.two?" two":""}">`+q.o.map((o,k)=>{
   const on=q.type==="multi"?(a&&a.ks.includes(k)):(a&&a.k===k);
   return `<button class="fq-opt${on?" sel":""}" data-k="${k}">
    ${q.type==="multi"?`<span class="fq-k box">${on?"✓":"&nbsp;"}</span>`:""}
    <span>${o.t}</span></button>`;}).join("")+`</div>`;
 } else if(q.type==="num"){
  body=`<div class="fq-inrow"><input class="fq-in" type="number" id="fq-x" min="${q.min}" max="${q.max}" value="${a?a.v:""}" placeholder="—"><span class="fq-unit">${q.unit}</span></div>`;
 } else if(q.type==="date"){
  body=`<input class="fq-in" type="date" id="fq-x" value="${a?a.raw:""}">`;
 } else {
  body=`<input class="fq-in" type="text" id="fq-x" value="${a?a.v:""}" placeholder="${q.ph||""}">`;
 }
 const badge=q.type==="multi"?`<span class="fq-badge">${q.need?"Scegline esattamente "+q.need:"Selezione multipla"}</span>`:"";
 const num=q.extra?(C.txt&&C.txt.laststep||"Letzter Schritt"):((C.txt&&C.txt.question||"Frage")+" "+String(st.i+1).padStart(2,"0"));
 $("#fq-q").innerHTML=`<div class="fq-qn">${num}</div><h2>${q.t}</h2>${q.h?`<p class="fq-hint">${q.h}</p>`:""}${badge}${body}`;

 if(q.type==="ch"||q.type==="multi"){
  $("#fq-q").querySelectorAll(".fq-opt").forEach(b=>b.addEventListener("click",()=>{
   const k=+b.dataset.k;
   if(q.type==="multi"){
    let ks=(st.a[st.i]&&st.a[st.i].ks)||[];
    if(q.o[k].x){ks=ks.includes(k)?[]:[k];}
    else{ks=ks.filter(x=>!q.o[x].x);
         ks=ks.includes(k)?ks.filter(x=>x!==k):ks.concat(k);
         if(q.need&&ks.length>q.need)ks=ks.slice(-q.need);}
    st.a[st.i]=ks.length?{ks,v:ks.map(x=>q.o[x].t).join(", "),ps:ks.map(x=>q.o[x].p||{}),
      f:ks.some(x=>q.o[x].f),ok:q.need?ks.length===q.need:true}:null;
    render();radar();
    if(q.need&&st.a[st.i]&&st.a[st.i].ok)setTimeout(next,260);
   } else {
    st.a[st.i]={k,v:q.o[k].t,p:q.o[k].p||{},f:!!q.o[k].f};
    render();radar();setTimeout(next,220);
   }
  }));
 } else {
  const x=$("#fq-x");
  x.addEventListener("input",()=>{
   if(q.type==="num"){const v=+x.value;st.a[st.i]=(v>=q.min&&v<=q.max)?{v,p:q.sc(v)}:null;}
   else if(q.type==="date"){st.a[st.i]=x.value?{raw:x.value,v:x.value.split("-").reverse().join("."),p:q.sc(x.value)}:null;}
   else{st.a[st.i]=x.value.trim().length>1?{v:x.value.trim(),p:{}}:null;}
   sync();radar();
  });
  x.focus();
 }
 R.querySelector('[data-a="back"]').style.visibility=st.i===0?"hidden":"visible";
 sync();
}
function sync(){
 const a=st.a[st.i],q=ALL[st.i],ok=a&&(q.type!=="multi"||a.ok);
 const b=R.querySelector('[data-a="next"]');
 b.disabled=!ok;b.textContent=st.i===ALL.length-1?(C.txt&&C.txt.create||"Formel erstellen"):(C.txt&&C.txt.next||"Weiter");
}
function next(){if(st.i<ALL.length-1){st.i++;render();}else analyse();}

function analyse(){
 stage("load");window.scrollTo({top:0});
 let p=0;
 const t=setInterval(()=>{
  p+=Math.random()*7+2;
  if(p>=100){p=100;clearInterval(t);setTimeout(results,450);}
  $("#fq-pc").textContent=Math.floor(p)+"%";
  $("#fq-arc").style.strokeDashoffset=478-(478*p/100);
  $("#fq-lt").textContent=p<35?"Analisi delle tue risposte":p<70?"Confronto con il tuo fabbisogno":"Composizione della formula";
 },110);
}

const F=C.formula;
const eu=n=>{var w=(C.waehrung||"€");
  if(w==="£"||w==="$") return w+n.toFixed(2);        // simbolo prima, punto decimale (UK/US)
  return n.toFixed(2).replace(".",",")+" "+w;};       // simbolo dopo, virgola (EUR/CHF)
const hasVergleich = F.preisVergleich && F.preisVergleich > F.preis;
const rabatt = hasVergleich ? Math.round((1-F.preis/F.preisVergleich)*100) : 0;

function results(){
 const t=scores(),rank=K.map(k=>({k,v:t[k]})).sort((a,b)=>b.v-a.v);
 st.rank=rank;
 const max=Math.max(1,rank[0].v);
 const name=st.a[0]?st.a[0].v:null;

 $("#fq-jar2").innerHTML=jar();
 $("#fq-title").textContent=name?`${name}, la tua formula è pronta.`:"La tua formula è pronta.";
 $("#fq-sub").textContent="Abbiamo letto tutte le 25 risposte. Queste sono le aree su cui la tua formula agisce per prime.";

 $("#fq-top").innerHTML=rank.slice(0,3).map((p,i)=>
  `<div class="fq-card"><div class="r">Priority ${i+1}</div><h3>${AREE[p.k].n}</h3>
   <p>${AREE[p.k].d}</p><div class="fq-m"><i style="width:${Math.max(20,Math.round(p.v/max*100))}%"></i></div></div>`).join("");

 const seen=new Set(),nutri=[];
 rank.slice(0,3).forEach(p=>AREE[p.k].nutri.forEach(([n,d])=>{if(!seen.has(n)){seen.add(n);nutri.push([n,d]);}}));
 $("#fq-nlist").innerHTML=nutri.map(([n,d])=>
  `<div class="fq-n"><span class="g"></span><span><b>${n}</b><span>${d}</span></span></div>`).join("");

 const flag=st.a.some(a=>a&&a.f);
 $("#fq-flag").innerHTML=flag
  ? `<div class="fq-flag"><b>Ti contatteremo prima di produrre la tua formula.</b>
     Hai indicato qualcosa che dobbiamo verificare — farmaci, gravidanza, una patologia o un'allergia non in elenco.
     Puoi completare l'ordine; ti contatteremo prima e ti consigliamo di consultare il tuo medico.</div>`
  : "";

 const tag=$("#fq-tag");
 if(hasVergleich){tag.textContent=`${rabatt}% Rabatt`;tag.style.display="inline-block";}
 else{tag.style.display="none";}
 $("#fq-buyt").textContent=name?`La formula di ${name}`:"La Tua Formula Personale";
 $("#fq-price").innerHTML=`<span class="now">${eu(F.preis)}</span>`+
   (hasVergleich?`<span class="was">Statt ${eu(F.preisVergleich)}</span><span class="off">Du sparst ${eu(F.preisVergleich-F.preis)}</span>`:"");
 $("#fq-det").textContent=F.detail;

 const keys=rank.slice(0,3).map(p=>p.k);
 let picks=C.upsell.filter(u=>u.bereiche.some(b=>keys.includes(b))).slice(0,C.maxUpsell);
 if(!picks.length)picks=C.upsell.slice(0,C.maxUpsell);
 $("#fq-ul").innerHTML=picks.map(u=>
  `<button class="fq-u" data-u="${u.id}">
   <span class="fq-uc">✓</span>
   ${u.bild?`<img class="fq-uimg" src="${u.bild}" alt="">`:`<span class="fq-uimg fq-uimg--ph"></span>`}
   <span class="fq-ub"><b>${u.name}</b><span>${u.warum}</span></span>
   <span class="fq-upr">${eu(u.preis)}</span></button>`).join("");
 $("#fq-ul").querySelectorAll(".fq-u").forEach(b=>b.addEventListener("click",()=>{
  const id=b.dataset.u;
  st.up.has(id)?st.up.delete(id):st.up.add(id);
  b.classList.toggle("sel",st.up.has(id));recalc();
 }));

 st.plan=true;recalc();
 stage("res");window.scrollTo({top:0});
}

function recalc(){
 let tot=st.plan?F.preis:0;
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)tot+=u.preis;});
 $("#fq-tot").textContent=st.plan?eu(tot):"—";
 const cons=["#fq-c1","#fq-c2","#fq-c3","#fq-c4"].every(s=>{var el=$(s);return !el||el.checked;});
 R.querySelector('[data-a="cart"]').disabled=!(st.plan&&cons);
}
R.addEventListener("change",e=>{if(e.target.matches("#fq-c1,#fq-c2,#fq-c3,#fq-c4"))recalc();});


/* --- aggiorna il contatore del carrello nell'header (Dawn e temi simili) --- */
function updateCartBadge(n){
  var sel=[".cart-count-bubble span[aria-hidden]",".cart-count-bubble span",
           "#cart-icon-bubble .cart-count-bubble span","#CartCount",".cart-item-count",
           "[data-cart-count]",".site-header__cart-count",".header__cart-count"];
  var done=false;
  sel.forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){ el.textContent=n; done=true; });
  });
  // se il pallino non esiste ancora (carrello vuoto all'apertura), lo creo
  if(!done){
    var icon=document.querySelector("#cart-icon-bubble, a[href$='/cart'], .header__icon--cart");
    if(icon && n>0 && !icon.querySelector(".cart-count-bubble")){
      var b=document.createElement("div");
      b.className="cart-count-bubble";
      b.innerHTML='<span aria-hidden="true">'+n+'</span>';
      icon.appendChild(b);
    }
  }
}

async function addToCart(){
 const btn=R.querySelector('[data-a="cart"]'),msg=$("#fq-msg");
 btn.disabled=true;btn.textContent="Aggiunta in corso…";
 const props={
  "Formel":st.rank.slice(0,3).map(p=>AREE[p.k].n).join(" · "),
  "Fragebogen":"25/25 risposte allegate"
 };
 ALL.forEach((q,i)=>{
  const a=st.a[i];
  const key=q.extra?"_★ "+q.lab:"_"+String(i+1).padStart(2,"0")+". "+q.lab;
  props[key]=a?(a.v+(q.unit?" "+q.unit:"")):"—";
 });
 if(st.a.some(a=>a&&a.f))props["_⚠️ VERIFICARE"]="Sì — contattare il cliente";

 // normalizza un variantId in intero pulito (evita notazione scientifica, spazi, decimali)
 function vid(x){
   if(typeof x==="number") return Math.round(x);
   var n=String(x).trim().replace(/[^\d]/g,"");   // tiene solo le cifre
   return n?parseInt(n,10):0;
 }
 const items=[{id:vid(F.variantId),quantity:1,properties:props}];
 st.up.forEach(id=>{const u=C.upsell.find(x=>x.id===id);if(u)items.push({id:vid(u.variantId),quantity:1});});

 if(C.demo){FQ_DIRTY=false;
  console.log("FQ — payload per /cart/add.js:",{items});
  msg.className="fq-msg ok";
  msg.textContent="Modalità demo. Apri la console del browser: ci sono tutte le risposte. Imposta demo: false quando vai in produzione.";
  btn.disabled=false;btn.textContent="Aggiungi al carrello";return;
 }
 try{
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items})});
  if(!r.ok)throw new Error(await r.text());
  FQ_DIRTY=false;

  // --- 1. conferma che il prodotto è DAVVERO nel carrello (fino a 5 tentativi) ---
  var count=0;
  for(var attempt=0; attempt<5; attempt++){
    try{
      var cr=await fetch("/cart.js",{headers:{"Accept":"application/json"},cache:"no-store"});
      var cart=await cr.json();
      count=cart.item_count||0;
      if(count>0) break;               // il carrello contiene già l'item: procedi
    }catch(e){}
    await new Promise(function(r){ setTimeout(r,150); });  // aspetta e riprova
  }
  console.log("FQ: carrello confermato, articoli =",count);
  updateCartBadge(count);

  // --- 2. l'app AMP slide-cart è inaffidabile su questo tema (mostra vuoto anche con articoli).
  //         Non apriamo il suo drawer: aggiorniamo il badge e diamo una conferma chiara.
  try{ if(window.Shopify && Shopify.actions && typeof Shopify.actions.cartUpdate==="function") Shopify.actions.cartUpdate(); }catch(e){}
  try{ document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true})); }catch(e){}
  try{ if(window.jQuery){ jQuery(document.body).trigger("added_to_cart"); } }catch(e){}

  // conferma inline forte: è QUESTA il segnale al cliente (il drawer AMP è inaffidabile)
  msg.className="fq-msg ok fq-added";
  msg.innerHTML=
    '<div class="fq-added-in">'+
      '<span class="fq-added-ic">✓</span>'+
      '<div class="fq-added-tx"><b>Aggiunto al carrello'+(count?' ('+count+' articolo'+(count>1?"i":"")+')':'')+'</b>'+
        '<span>You can add more products or go straight to checkout.</span></div>'+
      '<a class="fq-added-btn" href="/cart">Vai al carrello →</a>'+
    '</div>';
  msg.scrollIntoView({behavior:"smooth",block:"center"});
  btn.textContent="Aggiunto ✓";
  setTimeout(function(){ btn.disabled=false; btn.textContent="Aggiungi al carrello"; }, 1500);
 }catch(e){
  console.error(e);
  msg.className="fq-msg err";
  var det=(e&&e.message)?String(e.message):"";
  try{ var j=JSON.parse(det); det=(j.description||j.message||det); }catch(_){}
  msg.textContent="Impossibile aggiungere. "+(det?("Shopify: "+det.slice(0,220)):"Bitte erneut versuchen.");
  console.error("FQ add-to-cart error:", e);
  btn.disabled=false;btn.textContent="Aggiungi al carrello";
 }
}

R.addEventListener("click",e=>{
 const b=e.target.closest("[data-a]");if(!b)return;
 const a=b.dataset.a;
 if(a==="start"){FQ_DIRTY=true;stage("quiz");render();radar();window.scrollTo({top:0});}
 if(a==="back"&&st.i>0){st.i--;render();}
 if(a==="next")next();
 if(a==="pick"){$("#fq-c1").scrollIntoView({behavior:"smooth",block:"center"});}
 if(a==="cart")addToCart();
 if(a==="restart"){FQ_DIRTY=false;location.reload();}
});
/* --- Avviso prima di ricaricare/uscire mentre il quiz è in corso --- */
window.addEventListener("beforeunload",function(e){
  if(FQ_DIRTY){ e.preventDefault(); e.returnValue=""; return ""; }
});
document.addEventListener("keydown",e=>{
 if(!R.querySelector('[data-s="quiz"]').classList.contains("on"))return;
 const q=ALL[st.i];
 if(q.type==="ch"&&/^[1-9]$/.test(e.key)){
  const b=$("#fq-q").querySelector(`.fq-opt[data-k="${+e.key-1}"]`);if(b)b.click();
 }
 if(e.key==="Enter"&&!R.querySelector('[data-a="next"]').disabled)R.querySelector('[data-a="next"]').click();
});
})();